import { Link } from 'react-router-dom';
import useText from '@/hooks/useText';

function Footer() {
  const logo = useText('home.footer.logo');
  const desc = useText('home.footer.desc');
  const headingCompany = useText('home.footer.heading_company');
  const about = useText('home.footer.about');
  const docs = useText('navigation.docs');
  const press = useText('home.footer.press');
  const headingLegal = useText('home.footer.heading_legal');
  const legalNotice = useText('home.footer.legal_notice');
  const legalLicenses = useText('home.footer.legal_licenses');
  const privacy = useText('home.footer.privacy');
  const headingResources = useText('home.footer.heading_resources');
  const headingHelp = useText('home.footer.heading_help');
  const documentation = useText('home.footer.documentation');
  const support = useText('home.footer.support');
  const cite = useText('home.footer.cite');
  const copyright = useText('home.footer.copyright');
  const plans = useText('home.cta.btn_view_plans');
  const aboutOurCompany = useText('home.footer.about_our_company');
  const caseStudies = useText('home.footer.case_studies');
  const partners = useText('home.footer.partners');

  return (
    <footer className="home-footer">
      <div className="home-footer-container">
        <div className="home-footer-grid">
          <div className="home-footer-brand">
            <Link to="/" className="home-footer-logo">
              {logo}
            </Link>
            <p className="home-footer-desc">{desc}</p>
            <div className="home-footer-social">
              <a
                href="https://www.linkedin.com/company/medbioinformatics/"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <img
                  src="../../static/images/linkedin-in.svg"
                  alt="LinkedIn"
                  className="home-footer-social-icon"
                />
              </a>
              <a
                href="https://www.youtube.com/channel/UCGazBaBHYyx4-fIW8TZXYbg"
                target="_blank"
                rel="noreferrer"
                aria-label="YouTube"
              >
                <img
                  src="../../static/images/youtube.svg"
                  alt="YouTube"
                  className="home-footer-social-icon"
                />
              </a>
            </div>
          </div>
          <div className="home-footer-col">
            <h4 className="home-footer-heading">{headingCompany}</h4>
            <ul className="home-footer-links">
              <li>
                <Link to="https://medbioinformatics.com/">{aboutOurCompany}</Link>
              </li>
              <li>
                <a href="https://blog.disgenet.com/" target="_blank" rel="noreferrer">
                  {press}
                </a>
              </li>
              <li>
                <a href="https://casestudies.disgenet.com" target="_blank" rel="noreferrer">
                  {caseStudies}
                </a>
              </li>
              <li>
              <Link to="/partners">{partners}</Link>
              </li>
            </ul>
          </div>
          <div className="home-footer-col">
            <h4 className="home-footer-heading">{headingLegal}</h4>
            <ul className="home-footer-links">
              <li>
                <Link to="/legal-notice">{legalNotice}</Link>
              </li>
              <li>
                <Link to="/Legal">{legalLicenses}</Link>
              </li>
              <li>
                <Link to="/Privacy-policy">{privacy}</Link>
              </li>
            </ul>
          </div>
          <div className="home-footer-col">
            <h4 className="home-footer-heading">{headingResources}</h4>
            <ul className="home-footer-links">
              <li>
                <a href="/about" rel="noopener noreferrer">
                  {about}
                </a>
              </li>
              <li>
                <a href="/docs" rel="noopener noreferrer">
                  {docs}
                </a>
              </li>
              <li>
                <Link to="/docs?section=cite_us">{cite}</Link>
              </li>
              <li>
                <a href="/plans" rel="noreferrer">
                  {plans}
                </a>
              </li>
            </ul>
          </div>
          <div className="home-footer-col">
            <h4 className="home-footer-heading">{headingHelp}</h4>
            <ul className="home-footer-links">
              <li>
                <a href="https://support.disgenet.com/" target="_blank" rel="noopener noreferrer">
                  {documentation}
                </a>
              </li>
              <li>
                <Link to="/Support">{support}</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="home-footer-copy">{copyright}</div>
      </div>
    </footer>
  );
}

export default Footer;
